import React, { useEffect} from "react";
import { BiPlusCircle } from "react-icons/bi";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Breadcrumb from "../common/Breadcrumb";

const RoboticsPhoto = () => {  

  const images = [
    { id: 1, src: "images/gallery/robotics-1.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 2, src: "images/gallery/robotics-2.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 3, src: "images/gallery/robotics-3.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 4, src: "images/gallery/robotics-4.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 5, src: "images/gallery/robotics-5.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 6, src: "images/gallery/robotics-6.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 7, src: "images/gallery/robotics-7.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 8, src: "images/gallery/robotics-8.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 9, src: "images/gallery/robotics-9.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 10, src: "images/gallery/robotics-10.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 11, src: "images/gallery/robotics-11.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 12, src: "images/gallery/robotics-12.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
    { id: 13, src: "images/gallery/robotics-13.png", alt: "Robotics", title: "Robotics", group: "Robotics" },
  ];

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox='gallery']", {
      infinite: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      caption: (fancybox, slide) => {
        return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);


  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Robotics Photo" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>Robotics Photo</h2>
                <div className="curved-line mx-auto mt-3"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container row columns-3 popup-gallery full-screen">
                {images.map((image) => (
                  <div key={image.id} className="grid-item" data-group={image.group}>
                    <div className="portfolio-item">
                      <div className="position-relative">
                        <img
                          className="img-fluid"
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <a
                            data-fancybox="gallery"
                            data-caption={image.title}
                            href={image.src}
                            title={image.title}
                            className="portfolio-img"
                          >
                            <i>
                              <BiPlusCircle size={40} />
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RoboticsPhoto;
